import { Subject ,  Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';

export class LoadingService {
    uuid;
    count = 0;
    private subject = new Subject<boolean>();
    blockState$: Observable<boolean> = this.subject.asObservable();

    constructor() {
        this.uuid = uuid();
    }

    bloqueiaTela() {
        this.count++;
        this.subject.next(true);
    }

    liberaTela() {
        if (--this.count <= 0) {
            this.subject.next(false);
        }
    }
}
